import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { downloadMarkdownAsPdf } from "../../../core/utils/pdf";

export default function DownloadPdfButton({ markdown, disabled = false }) {
  const [busy, setBusy] = useState(false);

  const handleDownload = async () => {
    if (disabled || busy) return;
    const source = String(markdown ?? "").trim();
    if (!source) return;

    setBusy(true);
    try {
      await downloadMarkdownAsPdf(source);
    } catch {
      // Keep the response actions usable if PDF generation is blocked.
    } finally {
      setBusy(false);
    }
  };

  return (
    <Tooltip title={busy ? "Preparing PDF..." : "Download PDF"}>
      <span>
        <IconButton
          size="small"
          onClick={handleDownload}
          disabled={disabled || busy}
          aria-label="Download PDF"
          sx={{
            color: "rgba(255,255,255,0.7)",
          }}
        >
          <FileDownloadOutlinedIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
}
